import { api } from "./api";

const DB_NAME = "logidem-nomade";
const STORE = "queue";
const listeners = new Set();

const openDb = () => new Promise((resolve, reject) => {
  const req = indexedDB.open(DB_NAME, 1);
  req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

const withStore = async (mode, fn) => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(req?.result);
    t.onerror = () => reject(t.error);
  });
};

export const queueList = () => withStore("readonly", (s) => s.getAll());
const queueAdd = (item) => withStore("readwrite", (s) => s.add({ ...item, created: Date.now() }));
const queueRemove = (id) => withStore("readwrite", (s) => s.delete(id));
const notify = () => listeners.forEach((fn) => fn());

export const onQueueChange = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

const isNetworkError = (e) => !e.response;

const send = (item) => {
  if (item.form) {
    const fd = new FormData();
    Object.entries(item.form).forEach(([k, v]) => {
      if (v instanceof Blob) fd.append(k, v, v.name || `${k}.jpg`);
      else if (v != null) fd.append(k, v);
    });
    return api.request({ url: item.url, method: item.method, data: fd });
  }
  return api.request({ url: item.url, method: item.method, data: item.json });
};

export async function submit(item) {
  if (navigator.onLine) {
    try {
      const r = await send(item);
      return { queued: false, data: r.data };
    } catch (e) {
      if (!isNetworkError(e)) throw e;
    }
  }
  await queueAdd(item);
  notify();
  return { queued: true };
}

let syncing = false;
export async function syncQueue() {
  if (syncing || !navigator.onLine) return { done: 0, failed: 0 };
  syncing = true;
  let done = 0;
  let failed = 0;
  try {
    for (const item of await queueList()) {
      try {
        await send(item);
        await queueRemove(item.id);
        done += 1;
      } catch (e) {
        if (isNetworkError(e) || e.response.status === 401) break;
        await queueRemove(item.id);
        failed += 1;
      }
    }
  } finally {
    syncing = false;
    notify();
  }
  return { done, failed };
}

export async function cachedGet(url, params, cacheKey) {
  const key = `nomade-cache:${url}?${cacheKey || new URLSearchParams(params || {}).toString()}`;
  try {
    const r = await api.get(url, { params });
    try {
      localStorage.setItem(key, JSON.stringify(r.data));
    } catch (e) {
      // storage full: keep working online
    }
    return { data: r.data, offline: false };
  } catch (e) {
    const cached = isNetworkError(e) && localStorage.getItem(key);
    if (cached) return { data: JSON.parse(cached), offline: true };
    throw e;
  }
}

export const queuedMessage = (res, onlineMsg) => (res.queued ? "Hors ligne : enregistré sur l'appareil, synchronisation automatique au retour du réseau" : onlineMsg);
